import React, { useEffect, useState } from 'react';
import { message, Form, Input, Radio, Space, Card } from "antd";
import { Button } from "evergreen-ui";
import Firebase from "../../Firebase/Firebase";
import { getDatabase, ref } from "firebase/database";
import { useLocation, useParams } from "react-router-dom";
import { useListVals } from "../../Firebase/databaseHooks";
import FireFetch from "../../Firebase/FireFetch";
import { useAuth } from "../../AuthContext/AuthContext";



var db = getDatabase(Firebase);
const moment = require("moment");
const { TextArea } = Input;
const SurveyForm = () => {
	const { canAccessModule } = useAuth();
	const canSubmitForm = canAccessModule("FORMS", "create");

	const { id } = useParams();
	const [form] = Form.useForm();
	const location = useLocation();
	const survey = location.state?.survey || {};
	const [questions] = useListVals(ref(db, `talmidsdb/surveys/${id}/questions`));
	const [questionArray, setQuestionArray] = useState([]);
	const [result, setResult] = useState({});

	useEffect(() => {
		var questArray = (questions || [])
			.filter(q => q.surveyID === id)
			.sort((a, b) => Number(a.questionIndex ?? 0) - Number(b.questionIndex ?? 0));
		setQuestionArray([...questArray]);
	}, [id, questions]);

	const createArray = (min, max) => {
		var emptyArray = [];
		for (var i = Number(min); i <= Number(max); i++) {
			emptyArray.push(i);
		}
		return emptyArray;
	}

	const submitResponse = (values) => {
		if (!canSubmitForm) {
			message.error("You do not have permission to submit this form.");
			return;
		}

		var timeStamp = moment().format("YYYY-MM-DDTh:mm:ss");
		var responseID = Array(10).fill("ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz")
			.map(function (x) { return x[Math.floor(Math.random() * x.length)] }).join('');
		var object = {
			responseID: responseID,
			responses: result,
			surveyID: id,
			respondentID: "",
			timeStamp: timeStamp
		}
		FireFetch.SaveTODB("surveyResponses", responseID, object).then(() => {
			form.resetFields();
			setResult({});
			message.success("You response was submitted!");
		});
	}

	const onYesChange = (e, id) => {
		var object = { ...result };
		object[id] = e.target.value;
		setResult(object);
	}

	const onLinearChange = (e, id) => {
		var object = { ...result };
		object[id] = e.target.value;

		setResult(object);
	}

	const textChange = (e, id) => {
		var object = { ...result };
		object[id] = e.target.value;

		setResult(object);
	}

	return (
		<>

			<div className="d-flex justify-content-center align-items-center mt-5">
				<Card title={<b className="h4">{survey?.title || "Survey"}</b>} className="p-2">
					<>
						<Form
							form={form}
							layout="vertical"
							onFinish={submitResponse}
						>
							{
								questionArray.map((question, index) => (
									<Form.Item
										key={question.questionID || index}
										label={<b>{`${index + 1}. ${question.question}`}</b>}
										name={question.questionID}
									>
										{
											question.answerType === "Yes/No" ?
												<Radio.Group onChange={(e) => { onYesChange(e, question.questionID) }}>
													<Radio value={"Yes"}>Yes</Radio>
													<Radio value={"No"}>No</Radio>
													{
														question?.maybeOption === true ?
															<Radio value={"Maybe"}>Maybe</Radio>
															:
															null
													}
												</Radio.Group>
												:
												null
										}

										{
											question.answerType === "Linear Scale" ?
												<div className="d-flex flex-row">
													<p className="mr-3">
														{question.minLabel}
													</p>
													<Radio.Group onChange={(e) => { onLinearChange(e, question.questionID) }}>
														{
															createArray(question.min || 1, question.max || 5).map((item, index) => (
																<Radio key={index} value={item}>{item}</Radio>
															))
														}
													</Radio.Group>
													<p>
														{question.maxLabel}
													</p>

												</div>

												:
												null
										}

										{
											String(question.answerType || "").includes("Multiple Choice") ?
												<div className="d-flex flex-column">
													<Radio.Group onChange={(e) => { onLinearChange(e, question.questionID) }}>
														<Space direction="vertical">
															{
																(question.choiceOptions || []).map((item, index) => (
																	<Radio key={index} value={item}>{item}</Radio>
																))
															}
														</Space>

													</Radio.Group>

												</div>

												:
												null
										}

										{
											question.answerType === "Short answer" ?
												<Input placeholder="enter short answer" onChange={(e) => { textChange(e, question.questionID) }} />
												:
												null
										}

										{
											question.answerType === "Long answer" ?
												<TextArea placeholder="enter long answer" onChange={(e) => { textChange(e, question.questionID) }} />
												:
												null
										}
									</Form.Item>
								))
							}

							<Button appearance="primary" htmlType="submit" disabled={!canSubmitForm}>
								Submit
							</Button>

						</Form>
					</>
				</Card>


			</div>
		</>
	)
}

export default SurveyForm;
